export default [
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/Products/Index.vue'),
    meta: {
      pageTitle: 'Ürünler',
      breadcrumb: [
        {
          text: 'Ürünler',
          active: true,
        },
      ],
      resource: 'APP_PRODUCTS',
      action: 'read',
    },
  },
  {
    path: '/products/add',
    name: 'ProductsAdd',
    component: () => import('@/views/Products/Add.vue'),
    meta: {
      pageTitle: 'Ürün Ekle',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/products',
          active: false,
        },
        {
          text: 'Ekle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCTS',
      action: 'read',
    },
  },
  {
    path: '/products/edit/:id',
    name: 'ProductsEdit',
    component: () => import('@/views/Products/Edit.vue'),
    meta: {
      pageTitle: 'Ürün Güncelle',
      breadcrumb: [
        {
          text: 'Ürünler',
          to: '/products',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'APP_PRODUCTS',
      action: 'read',
    },
  },
]
